import React from 'react';
import styled from 'astroturf/react';

import { User } from 'js/liswp/Sidebar/hooks/types';

const PLACEHOLDER_PHOTO = '//c.academia-assets.com/images/s65_no_pic.png';

const Avatar = styled.img`
  border-radius: 50%;
  object-fit: cover;
`;

type Props = {
  user: User;
  small?: boolean;
};

const UserAvatar: React.FC<Props> = ({ user, small }) => (
  <Avatar
    src={user.photo || PLACEHOLDER_PHOTO}
    width={small ? 40 : 48}
    height={small ? 40 : 48}
  />
);

export default UserAvatar;
